import { Accordion, Col, Row } from "react-bootstrap";
import product_frequency from "../service/frequencyMapper.json";

const PPHIAppDetail = ({ ppphiData }) => {
    return (
        <div className="account-wrapper mb-5">
            <Accordion defaultActiveKey={0} alwaysOpen>
                {ppphiData?.applications?.map((item, index) => {
                    return (
                        <Accordion.Item eventKey={index} key={index}>
                            <Accordion.Header>
                                <span>
                                    Application No. {item.product_number}
                                    <span className="status-chip">
                                        {item.level}
                                    </span>
                                </span>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="order-item-bottom">
                                    <Row className="px-0 px-sm-3 ps-0">
                                    <Col md={6} className="pe-0 border-end-pphi pe-sm-3 ps-0">
                                            <h5>Insured Details</h5>
                                            <div className="item-wrapper-pphi">
                                                <div className="item-title">Name</div>
                                                <div className="item-content">
                                                    {item.insured_name}
                                                </div>
                                            </div>

                                            <div className="item-wrapper-pphi">
                                                <div className="item-title">Age</div>
                                                <div className="item-content">
                                                    {item.insured_age} Yrs
                                                </div>
                                            </div>
                                            <div className="item-wrapper-pphi">
                                                <div className="item-title">PAN</div>
                                                <div className="item-content">
                                                    {item.pan_no}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6} className="ps-0 ps-sm-3">
                                            <h5>Plan Details</h5>
                                            <div className="item-wrapper-pphi">
                                                <div className="item-title">
                                                    Policy Sum Assured
                                                </div>
                                                <div className="item-content">
                                                    ₹
                                                    {item.product_sum_assured.toLocaleString(
                                                        "en-IN"
                                                    )}
                                                </div>
                                            </div>
                                            <div className="item-wrapper-pphi">
                                                <div className="item-title">
                                                    Plan Name
                                                </div>
                                                <div className="item-content">
                                                    {item.product_name || "-"}
                                                </div>
                                            </div>
                                            <div className="item-wrapper-pphi">
                                                <div className="item-title">
                                                    Payment Frequency
                                                </div>
                                                <div className="item-content">
                                                    {product_frequency[
                                                        `${item.product_frequency}`
                                                    ] || "-"}
                                                </div>
                                            </div>
                                            <div className="item-wrapper-pphi">
                                                <div className="item-title">
                                                    Policy Term
                                                </div>
                                                <div className="item-content">
                                                    {item.product_benifit_term}
                                                </div>
                                            </div>
                                            <div className="item-wrapper-pphi">
                                                <div className="item-title">
                                                    Paid Amount
                                                    <div
                                                        className="tooltip-container"
                                                        data-testid="tooltip-container"
                                                    >
                                                        <span className="info-icon-wrapper d-sm-block">
                                                            <span className="info-icon">
                                                                i
                                                            </span>
                                                        </span>
                                                        <div className="tooltip pphi-tooltip-wrapper">
                                                            <div className="tooltip-c ">
                                                                <p>Total Amount </p>
                                                                <p className="total-pphi">
                                                                    {item.paid_amount
                                                                        ? `₹${item.paid_amount.toLocaleString(
                                                                            "en-IN"
                                                                        )}`
                                                                        : "-"}
                                                                </p>
                                                            </div>
                                                            <hr className="py-0 my-2" />
                                                            {item.existing_soft_or.map(
                                                                (ele, index) => (
                                                                    <div>
                                                                        <div className="tooltip-c pphi-tooltip">
                                                                            <p>Payment Method : </p>

                                                                            <p className="payment-pphi">
                                                                                {" "}
                                                                                {ele.softOrInstrument}
                                                                            </p>
                                                                        </div>
                                                                        <div className="tooltip-c pphi-tooltip">
                                                                            <p>Payment Amount : </p>

                                                                            <p className="payment-pphi">
                                                                                {" "}
                                                                                ₹{ele.softOrAmount}
                                                                            </p>
                                                                        </div>
                                                                        <div className="tooltip-c pphi-tooltip">
                                                                            <p>OR Number :</p>

                                                                            <p className="payment-pphi">
                                                                                {" "}
                                                                                {ele.orNumber}
                                                                            </p>
                                                                        </div>
                                                                        {item.existing_soft_or
                                                                            .length -
                                                                            1 !=
                                                                            index && (
                                                                                <hr className="my-2" />
                                                                            )}
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="item-content">
                                                    {item.paid_amount
                                                        ? `₹${item.paid_amount.toLocaleString(
                                                            "en-IN"
                                                        )}`
                                                        : "-"}
                                                </div>
                                            </div>
                                            <div className="item-wrapper-pphi">
                                                <div className="item-title">
                                                    Pending Amount
                                                </div>
                                                <div className="item-content">
                                                    {item.pending_amount
                                                        ? `₹${item.pending_amount.toLocaleString(
                                                            "en-IN"
                                                        )}`
                                                        : "₹0"}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    );
                })}
            </Accordion>
        </div>
    );
}

export default PPHIAppDetail;